import { render, staticRenderFns } from "./InfoCumplimientos.vue?vue&type=template&id=05a7ca86&"
import script from "./InfoCumplimientos.vue?vue&type=script&lang=ts&"
export * from "./InfoCumplimientos.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCumplimientos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports